import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Problems() {
  return (
    <section className="problem_section_novel p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={10}
            xxl={10}
            className="mx-auto text-center"
          >
            <h2>The Problem</h2>
            <p>
              We knew that the biggest challenge with a project of this
              magnitude would be to get every detail exactly right, and make
              sure the representation of characters would satisfy even the
              staunchest of fans. Every character’s model was based on the
              descriptions in the novel, from eye color to hair texture, so our
              team had to make sure that everything was absolutely accurate.
            </p>
            <div className="img_problem">
              <StaticImage
                src="../../../images/case-studies/novelcraft/tek_img_02.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={577}
                height={890}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center offset-lg-1 "
          ></Col>
        </Row>
      </Container>
    </section>
  );
}

export default Problems;
